import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { FOfferType, getRangeValue, offerTypeFromJsonQuery } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectTotalArea = createSelector(selectJsonQuery, jsonQuery => {
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const field = (offerType & FOfferType.CommercialLand) !== 0 ? 'site' : 'total_area';

  return getRangeValue(field)(jsonQuery) || DEFAULT_RANGE_VALUE;
});
